export default __webpack_public_path__ + "static/media/how-payments-work.437f1759.png";